import React, { useEffect, useRef, useState } from "react";

const DisbursementDetailsInfo = (props) => {
  const infoForm = useRef(null);
  const [disbursementInfoData, setDisbursementInfoData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const [searchdata, setSearchdata] = useState({});

  const disbursementInfoCardData = [
    {
      title: "Total Disbursement",
      count:
        disbursementInfoData?.totalDisbursement?.totalDisbursementCount || 0,
      amount:
        disbursementInfoData?.totalDisbursement?.totalDisbursedAmount || 0,
      icon: imagepaths.dollarCollectionIcon,
      path: `/app/salesinfo?cardname=totalDisbursement&timeline=${searchdata?.start_date ? "CUSTOM" : timeline
        }&start_date=${searchdata?.start_date || null}&end_date=${searchdata?.end_date || null
        }`,
    },
    {
      title: "DSA",
      count: disbursementInfoData?.dsa?.channelDisbursementCount || 0,
      amount: disbursementInfoData?.dsa?.channelDisbursedAmount || 0,
      icon: imagepaths.dollarBagIcon,
      path: `/app/salesinfo?cardname=dsa&timeline=${searchdata?.start_date ? "CUSTOM" : timeline
        }&start_date=${searchdata?.start_date || null}&end_date=${searchdata?.end_date || null
        }`,
    },
    {
      title: "Digital",
      count: disbursementInfoData?.digital?.channelDisbursementCount || 0,
      amount: disbursementInfoData?.digital?.channelDisbursedAmount || 0,
      icon: imagepaths.coinStackIcon,
      path: `/app/salesinfo?cardname=digital&timeline=${searchdata?.start_date ? "CUSTOM" : timeline
        }&start_date=${searchdata?.start_date || null}&end_date=${searchdata?.end_date || null
        }`,
    },
    {
      title: "Tele Calling",
      count: disbursementInfoData?.teleCalling?.channelDisbursementCount || 0,
      amount: disbursementInfoData?.teleCalling?.channelDisbursedAmount || 0,
      icon: imagepaths.percentageRoundedIcon,
      path: `/app/salesinfo?cardname=telecalling&timeline=${searchdata?.start_date ? "CUSTOM" : timeline
        }&start_date=${searchdata?.start_date || null}&end_date=${searchdata?.end_date || null
        }`,
    },
    {
      title: "Sales officer",
      count: disbursementInfoData?.salesOfficer?.channelDisbursementCount || 0,
      amount: disbursementInfoData?.salesOfficer?.channelDisbursedAmount || 0,
      icon: imagepaths.percentageRoundedIcon,
      path: `/app/salesinfo?cardname=salesofficer&timeline=${searchdata?.start_date ? "CUSTOM" : timeline
        }&start_date=${searchdata?.start_date || null}&end_date=${searchdata?.end_date || null
        }`,
    },
  ];

  // DISBURSEMENT DETAILS INFO
  const getTotalDisbursement = (query, params) => {
    let data = {
      ...query,
      timeline: params || timeline,
    };

    let payload = {};

    props.apis.apiGetAdminDashboardRevenueAndDisbursement(data, payload).then((res) => {
      let disbursementData = {
        totalDisbursement: {
          totalDisbursementCount: res?.total?.count,
          totalDisbursedAmount: res?.total?.amount,
        },
        dsa: {
          channelDisbursementCount: res?.dsa?.count,
          channelDisbursedAmount: res?.dsa?.amount,
        },
        digital: {
          channelDisbursementCount: res?.digital?.count,
          channelDisbursedAmount: res?.digital?.amount,
        },
        teleCalling: {
          channelDisbursementCount: res?.teleCalling?.count,
          channelDisbursedAmount: res?.teleCalling?.amount,
        },
        salesOfficer: {
          channelDisbursementCount: res?.salesOfficer?.count,
          channelDisbursedAmount: res?.salesOfficer?.amount,
        },
      };
      setDisbursementInfoData(disbursementData);
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "disbursement-column-start_date",
      "disbursement-column-end_date",
      "disbursement-column-search_btn",
      "disbursement-column-reset_btn",
    ];
    // console.log({ val });
    props.onTimelineChange(val);
    if (val === "CUSTOM") {
      showInputs(inputs);
      setDisbursementInfoData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    props.onCustomTimelineChange(queryData);
    setSearchdata(queryData);
    getTotalDisbursement(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "disbursement-column-start_date",
      "disbursement-column-end_date",
      "disbursement-column-search_btn",
      "disbursement-column-reset_btn",
    ];
    props.onCustomTimelineChange({});
    hideInputs(inputs);
    getTotalDisbursement({}, "TODAY");
  };

  useEffect(() => {
    getTotalDisbursement({}, timeline);
  }, [timeline]);

  props.$setNode({
    props,
    disbursementInfoData,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="form_outer">
          <AppForm
            ref={infoForm}
            onSubmit={(...args) => onSearch(...args)}
            className="row justify-content-end"
          >
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2"
              id="column-timeline"
            >
              <AppInputFocus
                type="select"
                name="timeline"
                label="Time Line"
                options={_enum.OVERALL_DETAIL}
                onChange={(...args) => handleDateChange(...args)}
                defaultValue={"TODAY"}
                placeholder="Time Line"
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="disbursement-column-start_date"
            >
              <AppInputFocus
                type="date"
                name="start_date"
                label="Start Date"
                placeholder="Start Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
              id="disbursement-column-end_date"
            >
              <AppInputFocus
                type="date"
                name="end_date"
                label="End Date"
                placeholder="End Date"
                required={true}
              ></AppInputFocus>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="disbursement-column-search_btn"
            >
              <button type="submit" className="btn btn-primary search_btn">
                <i className="fa fa-search"></i>
                <span>Search</span>
              </button>
            </div>
            <div
              className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
              id="disbursement-column-reset_btn"
            >
              <button
                type="button"
                className="btn btn-primary search_btn"
                onClick={(...args) => resetSearchForm(...args)}
              >
                <i class="fa-solid fa-filter-circle-xmark"></i>
                <span>Search</span>
              </button>
            </div>
          </AppForm>
        </div>
        <div className="row pt-0 pt-md-4">
          {disbursementInfoCardData &&
            disbursementInfoCardData.map((revenue) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    onClick={(...args) => navigate(revenue?.path)}
                  >
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="border_bottom_line"></div>
                      <div className="card-body">
                        <div className="icon_container">
                          <p className="icon_title">{revenue?.title}</p>
                          <div className="icon">
                            <img src={revenue?.icon} alt="icon image" />
                          </div>
                        </div>
                        <div className="content">
                          <p className="count">{revenue?.count}</p>
                          <p className="card_label">
                            Amount :{" "}
                            <span className="primary-red ms-1">
                              {revenue?.amount?.cur()}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(DisbursementDetailsInfo);
